<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6">
        <v-btn
          block
          min-height="200px"
          :outlined="createFromScratchOutlined"
          color="primary"
          style="font-size: 30px"
          :disabled="createFromScratchDisabled"
          @click="createFromScratchClickedHandler"
        >
          Create From<br>Scratch
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn
          block
          min-height="200px"
          :outlined="createFromZohoOutlined"
          color="primary"
          style="font-size: 30px"
          :disabled="createFromZohoDisabled"
          @click="createFromZohoClickedHandler"
        >
          Create From<br>Zoho
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="6" md="3" class="pl-2" v-if="!!id || !!dealCreationTypeId">
        <v-btn
          block
          color="primary"
          depressed
          @click="nextStep"
        >
          Next
        </v-btn>
      </v-col>
      <v-col cols="6" md="3" class="pl-2">
        <v-btn
          block
          outlined
          depressed
          @click="cancel"
        >
          Cancel
        </v-btn>
      </v-col>
    </v-row>
    <ZRJobOpeningsModal
      ref="ZRJobOpeningsModal"
      @importFromZoho="importFromZohoHandler"
    ></ZRJobOpeningsModal>
  </div>
</template>

<script>
import { ButtonsSubmitForm } from '@/components/buttons'
import { dealsRoute } from '@/lib/constants/routes'
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { CREATE_FROM_SCRATCH, CREATE_FROM_ZOHO } from '@/lib/constants/dealCreationTypes'
import ZRJobOpeningsModal from '@/components/deals/dealComponents/ZRJobOpeningsModal'

export default {
  props: [
    'readonly'
  ],
  components: {
    ButtonsSubmitForm,
    ZRJobOpeningsModal
  },
  data () {
    return {
      isFormValid: null,
      dealId: null,
      createFromScratchOutlined: true,
      createFromZohoOutlined: true,
      createFromScratchDisabled: false,
      createFromZohoDisabled: false,
      CREATE_FROM_SCRATCH,
      CREATE_FROM_ZOHO
    }
  },
  computed: {
    ...mapFields('deal', ['id', 'dealCreationTypeId']),
    ...mapFields('settings', ['zohoIntegrationSettings'])
  },
  methods: {
    ...mapActions('deal', ['saveDeal']),
    createFromScratchClickedHandler (showDealSavedMessage = true) {
      if (!this.readonly) {
        this.createFromScratchOutlined = false
        this.dealCreationTypeId = CREATE_FROM_SCRATCH
        this.nextStep(showDealSavedMessage)
      }
    },
    importFromZohoHandler (jobOpening) {
      this.createFromZohoOutlined = false
      this.dealCreationTypeId = CREATE_FROM_ZOHO
      this.disableButtons()
      this.$emit('importFromZoho', jobOpening)
    },
    createFromZohoClickedHandler () {
      if (!this.readonly && !this.id) {
        this.$refs.ZRJobOpeningsModal.showModal()
      }
    },
    nextStep (showDealSavedMessage = true) {
      if (!this.readonly && this.dealCreationTypeId !== CREATE_FROM_ZOHO) {
        this.saveDeal(showDealSavedMessage).then(() => {
          this.$emit('complete')
          this.disableButtons()
        })
      } else {
        this.$emit('complete')
      }
    },
    cancel () {
      this.$router.push({ name: dealsRoute.name })
    },
    disableButtons () {
      if (this.dealCreationTypeId === CREATE_FROM_SCRATCH) {
        this.createFromScratchOutlined = false
        this.createFromZohoDisabled = true
      }
      if (this.dealCreationTypeId === CREATE_FROM_ZOHO) {
        this.createFromZohoOutlined = false
        this.createFromScratchDisabled = true
      }
    }
  }
}
</script>
